import { makeStyles, Theme } from '@material-ui/core';

export default makeStyles((_theme: Theme) => ({
    modal: {
        marginTop: 64,
    },
}));
